import { render, staticRenderFns } from "./ErnaehrungUndGesundheit.vue?vue&type=template&id=446dd622&"
import script from "./ErnaehrungUndGesundheit.vue?vue&type=script&lang=js&"
export * from "./ErnaehrungUndGesundheit.vue?vue&type=script&lang=js&"
import style0 from "./ErnaehrungUndGesundheit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports